<div class="modal-header">
  <h4 class="modal-title pull-left">Archive Reports (ROT, Quoted, and Order Received)</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <form name="form" #f="ngForm" novalidate>
    <div class="row">
      <div class="col-sm-12">
        <div class="form-group">
          <label class="rbv-label">Days to Keep Reports from Archive</label>
          <input type="number" [(ngModel)]="noOfDays" placeholder="Enter Number of Days" class="form-control rounded-0"
                 name="noOfDays" maxlength="10" autocomplete="off" required (keydown.enter)="onConfirm()" autofocus="autofocus"/>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button class="btn btn-rbv" [disabled]="!f.valid" (click)="onConfirm()">Submit</button>
</div>
